export default __webpack_public_path__ + "static/media/me.1c643322.png";